import separateOverlappingBars from "PFApp/booking/parts/helpers/separate_overlapping_bars";
import { Bar, CalendarMode, MisalignmentItem } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";
import { useMemo } from "react";

import { Row } from "../../../types";
import { useBookingRowsContext } from "../../overview/context/booking_rows_context";
import { getMisalignmentItemsByRow } from "./get_misalignment_items_by_row";

interface UseMisalignments {
  row: Row;
  mode: CalendarMode;
}
interface UseMisalignmentsReturn {
  rowMisalignments: MisalignmentItem[];
  misalignmentBars: Bar[][];
}

const useMisalignments = ({ row, mode }: UseMisalignments): UseMisalignmentsReturn => {
  const { rowsByCalendarMode, warningsByActivity } = useBookingRowsContext();

  const rowMisalignments = useMemo(() => {
    const parents = rowsByCalendarMode[mode].filter(({ key }) => row.parents.includes(key));
    return mode === CalendarMode.Projects ? getMisalignmentItemsByRow(row, warningsByActivity, parents) : [];
  }, [row, rowsByCalendarMode, warningsByActivity, mode]);

  const misalignmentBars = useMemo(
    () =>
      row.type === RowType.Profile
        ? separateOverlappingBars(
            rowMisalignments.map((i) => ({ ...i, start: i.start_date, end: i.end_date }))
          )
        : [],
    [row.type, rowMisalignments]
  );
  return {
    rowMisalignments,
    misalignmentBars
  };
};

export default useMisalignments;
